/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import { EventModelFromJSON, EventModelFromJSONTyped, EventModelToJSON } from './EventModel';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';

/**
 *
 * @export
 * @interface ResponseGetEventApiV1EventsEventGet
 */
export interface ResponseGetEventApiV1EventsEventGet {
    /**
     *
     * @type {any}
     * @memberof ResponseGetEventApiV1EventsEventGet
     */
    id: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEventApiV1EventsEventGet
     */
    title: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEventApiV1EventsEventGet
     */
    description: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEventApiV1EventsEventGet
     */
    link: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEventApiV1EventsEventGet
     */
    date: any | null;
    /**
     *
     * @type {FileUrl}
     * @memberof ResponseGetEventApiV1EventsEventGet
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ResponseGetEventApiV1EventsEventGet interface.
 */
export function instanceOfResponseGetEventApiV1EventsEventGet(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('description' in value)) return false;
    if (!('link' in value)) return false;
    if (!('date' in value)) return false;
    return true;
}

export function ResponseGetEventApiV1EventsEventGetFromJSON(
    json: any,
): ResponseGetEventApiV1EventsEventGet {
    return ResponseGetEventApiV1EventsEventGetFromJSONTyped(json, false);
}

export function ResponseGetEventApiV1EventsEventGetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ResponseGetEventApiV1EventsEventGet {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        description: json['description'],
        link: json['link'],
        date: json['date'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ResponseGetEventApiV1EventsEventGetToJSON(
    value?: ResponseGetEventApiV1EventsEventGet | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        description: value['description'],
        link: value['link'],
        date: value['date'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
